import React from 'react';
import {
  Text, View, StyleSheet,
} from '@react-pdf/renderer';
import _ from 'underscore';
import Space from './space';


const styles = StyleSheet.create({
  header: {
    backgroundColor: '#00A7B8',
    color: 'white',
    padding: 10,
    paddingTop: 5,
    paddingBottom: 5,
    marginTop: 2,
    marginBottom: 3,
    fontFamily: 'MuliExtraBold',
    fontSize: 14,

  },
  subtitles: {
    fontFamily: 'MuliRegular',
    fontSize: 16,
  },
  gap: {
    marginLeft: 3,
  },
  list: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  table: {
    flexDirection: 'row',
  },
  blueTransparentField: {
    padding: 10,
    backgroundColor: '#eeeeee',
    borderColor: '#dddddd',
    marginTop: 5,
    fontFamily: 'MuliRegular',
    fontSize: 12,
  },
  blueConnected: {
    backgroundColor: '#eeeeee',
    fontFamily: 'MuliRegular',
    fontSize: 12,
    padding: 10,
    borderColor: '#dddddd',
    marginTop: -1,
  },
  startText: {
    paddingLeft: 20,
  },
});
const TablePDF = ({
  catsList = [],
  amount = 0,
}) => {
  const titles = [
    ['Test to be Booked'],
    ['Categories to be renewed'],
  ];

  const RenderTitles = () => titles.map((item, index) => (
    <Text key={`text${index}`} style={{ flex: 1, marginLeft: (index === 1) ? 25 : 0 }}>{titles[index]}</Text>

  ));

  const RenderDocument = () => catsList.map((row, index) => (
    <View key={`row${index}`} style={{ flexDirection: 'row' }}>
      {row.cells.map((cell, pos) => {
        if (cell.type === 'link') {
          return (
            <View key={`${cell.text}${pos}`} style={[styles.blueTransparentField, { flex: 1 }]}>
              <Text>
                {cell.text}
              </Text>
            </View>
          );
        }
        if (pos === 0 && cell.type !== 'link') {
          return (
            <>
              <View style={[styles.blueConnected, { flex: 1 }]} />
              <Text style={[styles.blueConnected, styles.gap, { flex: 1 }]}>
                {cell.text}
              </Text>
            </>
          );
        }
        return (
          <View key={`${cell.text}2`} style={[styles.blueTransparentField, styles.gap, { flex: 1, flexDirection: 'row' }]}>
            <Text>
              {cell.text}
            </Text>
          </View>
        );
      })}
    </View>
  ));

  return (
    <>
      {
      (!_.isEmpty(catsList))
        ? (
          <>
            <Text style={styles.subtitles}>
              {`You are required to sit ${amount} tests`}
            </Text>
            <Space />
            <View style={[styles.header, { flexDirection: 'row' }]}>
              {RenderTitles()}
            </View>
            {RenderDocument()}
          </>
        )
        : null
      }
    </>
  );
};

export default TablePDF;
